import { memo, useState } from 'react';
import { MenuMobileContext } from './MenuMobileContext';
import { IChildrenProps } from 'interfaces/general.interface';

const MenuMobileProvider = ({ children }: IChildrenProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const setIsOpenAction = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <MenuMobileContext.Provider value={{ isOpen, setIsOpenAction }}>
      {children}
    </MenuMobileContext.Provider>
  );
};

export default memo(MenuMobileProvider);
